import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonDto } from '../../../core/dto/person';
import { MetadataService } from '../../../core/services/metadata.service';

@Component({
    selector: 'isav-people-view-page',
    templateUrl: './people-view-page.html',
    styleUrls: ['./people-view-page.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleViewPage {
    readonly person$: Observable<PersonDto> = this.route.data.pipe(
        pluck('person'),
        this.metaService.seo('fullName')
    );

    constructor(
        private readonly route: ActivatedRoute,
        private metaService: MetadataService,
        public router: Router
    ) {}
}
